jQuery(document).ready(function ($) {
    let tabs = ['Oddstoppscorerliste', 'Ligastatistikk', 'Maratontabell']; 

    $('body.page-template-single-league .tabs ul.tabs-list li > a').on('click', (e) => {
        let season = $(e.target).data("season");
        let active_tab = $(e.target).attr("href").replace('#', '');
        let action = tabs.includes($(e.target).text()) ? $(e.target).text().toLowerCase() : 'get_league_level';
        $.ajax({
            datatype: 'html',
            url: script_object.ajax_url,
            type: 'POST',
            data: {
                'action': action,
                'data': {
                    season: season,
                    level: $(e.target).text()
                }
            },
            beforeSend: () => {
                $('.fantasy-league-loader').show();
                $('.fantasy-overlay').show();
            },
            success: (data) => {
                var $ajax_response = $(data);
                $('#' + active_tab).append($ajax_response);
                add_tab_actions();
                $('.fantasy-overlay').hide();
                $('.fantasy-league-loader').hide();
            },
        }); 
    });

    function add_tab_actions() {
        $(".tabs-fantasy-list li a").on('click', function (e) {
            e.preventDefault();
        });
        $(".tabs-fantasy-list li").on('click', function () {
            var tabid = $(this).find("a").attr("href");
            $(".tabs-fantasy-list li,.tabs-fantasy div.tab-fantasy").removeClass("active"); // removing active class from tab

            $(".tab-fantasy").hide(); // hiding open tab
            $(tabid).show();
            $(this).addClass("active"); //  adding active class to clicked tab
        });

        var li = document.querySelectorAll('.tabs-list li');
        li.forEach((element) => {
            element.addEventListener("click", function (e) {
                var li_child = document.querySelectorAll('.tabs-fantasy-list');
                var tabs_child = document.querySelectorAll('.tab');
                li_child.forEach((e) => {
                    for (let index = 0; index < e.children.length; index++) {
                        if (index == 0) {
                            if (!e.children[index].classList.contains('active')) {
                                e.children[index].classList.add('active');
                            }
                        } else {
                            e.children[index].classList.remove('active');
                        }
                    }
                });
                tabs_child[this.getAttribute('index')].style.display = "block";
                var tab_fantasy = tabs_child[this.getAttribute('index')].querySelectorAll('.tab-fantasy');
                for (let index = 0; index < tab_fantasy.length; index++) {
                    tab_fantasy[index].style.display = "none";
                    if (index == 0) {
                        tab_fantasy[0].style.display = "block";
                    }
                }
            }, false);
            $('.oddsnet-ligaen').dataTable({
                "order": [[ 5, "png" ], [ 6, "odds" ]],
                paging: false,
                searching: false,
                retrieve: true,
                info: false,
            });            
        });
        // $( ".tab-fantasy" ).each(function( index ) {
        //     if(!$(this).find('span').hasClass('ranked')){
        //         $(this).find(".ranking").find("td").first().prepend("<span class='ranked'>"+ "#1 " +'</span>');
        //     }
        // });
        // $( ".tab" ).each(function( index ) {
        //     if(!$(this).find('span').hasClass('ranked')){
        //         $(this).find(".ranking").find("td").first().prepend("<span class='ranked'>"+ "#1 " +'</span>');
        //     }
        // });
    }
    $('.oddsnet-ligaen').dataTable({
        "order": [[ 5, "png" ], [ 6, "odds" ]],
        paging: false,
        searching: false,
        retrieve: true,
        info: false,
    });
});

